import { render } from "./ApprovalsListCardHistory.vue?vue&type=template&id=36447564"
import script from "./ApprovalsListCardHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__